import { AdState } from "../interfaces/credits.interfaces";

function generateDefaultAdStates(count: number): AdState[] {
  return Array.from({ length: count }, (_, index) => ({
    id: index + 1,
    watched: false,
    locked: index !== 0,
    timeRemaining: 0,
    watchedAt: undefined as undefined,
    isLoading: false,
    isRewareded: false,
    isLoaded: false,
  }));
}

/** Platinum credits granted for watching a single rewarded ad. Lives here rather than in
 *  ad-list.component.ts so importers don't pull in the native ad SDK. */
export const WATCH_AD_REWARD = 1;

export const DEFAULT_AD_STATES: AdState[] = generateDefaultAdStates(5);

export const PURCHASE_ID_KEY = "GLOSS_CREDIT_PURCHASE_ID";
// CreditsService's conversions whose outcome is unknown, kept across a reload or an app kill so a
// relaunched drawer retries under the same conversionId instead of converting twice (#6247).
export const UNRESOLVED_CONVERSIONS_KEY = "GLOSS_CREDIT_UNRESOLVED_CONVERSIONS";
// Pre-hash query param gloss-credit appends on Stripe success (before #/… in hash routing).
export const STRIPE_RETURN_PURCHASE_ID_PARAM = "purchase_id";
// Written alongside PURCHASE_ID_KEY so a force-kill cannot leave the key orphaned forever.
// checkAndReactToPurchaseHistory clears both keys when the timestamp is older than PURCHASE_ID_MAX_AGE_MS.
export const PURCHASE_ID_TS_KEY = "GLOSS_CREDIT_PURCHASE_TS";
// The selected pack's price/currency/credits and its purchaseId, stashed client-side before the
// Stripe redirect so the "Credits added" receipt can show "Paid {amount} {currency}" on return —
// PurchaseDetail (the backend's status response) never carries this, only credits/newBalance. The
// receipt uses it only when its purchaseId is the purchase that was finalized.
export const PURCHASE_ID_PACK_KEY = "GLOSS_CREDIT_PURCHASE_PACK";
export const PURCHASE_ID_MAX_AGE_MS = 30 * 60 * 1000; // 30 minutes
export const LAST_PURCHASE_CHECK_KEY = "GLOSS_LAST_PURCHASE_CHECK";

/** Platinum → Gold conversion rate. Client-side display estimate only (Locked Decision #7) —
 *  never sent to the server, which is the sole source of truth via the `/convert` response. */
export const GOLD_MULTIPLIER = 10;

/** Gold-credits-per-AUD rate quoted on both the "Buy with Cash" header badge
 *  (points-purchase.component.ts) and the Amazon Gift Card redemption screen
 *  (amazon-gift-card.component.ts) — kept as one constant so the two screens can't silently
 *  quote different rates to the user. */
export const GC_PER_AUD = 100;
